import { getSettingData } from "@/api/myPractice"
import { isObjEmpty } from "./helper";
import useUtilities from "@/views/setting/my-practice/service/UseUtilities";

const { getUserFullName } = useUtilities();

// Shared in-flight request for getSettingData. Several places dispatch this
// action around the same time (the settings page kicks it off fire-and-forget
// when user info lands, while AccountInfo awaits it before snapshotting the
// data into its form). The isObjEmpty guard alone only dedupes AFTER the
// response commits, so concurrent dispatches would each fire their own request
// and the awaiting one could not observe the other's completion.
let pendingFetch = null;

const account = {
    namespaced: true,
    state: {
        old_personal: {},
        old_practice: {},
        infoURL: '/setting/getAccountInfo',
        postpersonalURL: '/setting/setAccountInfo'
    },
    getters: {
        old_practice: state => state.old_practice,
        old_personal: state => state.old_personal,
        personalURL: state => state.postpersonalURL,
        user_name: state => state.old_personal.user_name,
        user_id: state => state.old_personal.user_id,
        provider_name: state => {
            const {customer_first_name,customer_last_name}=state.old_personal;
            return getUserFullName(customer_first_name,customer_last_name)
        } ,
        manager: state => [state.old_personal.vibrant_sales_firstname + ' ' + state.old_personal.vibrant_sales_lastname, state.old_personal.vibrant_sales_email, state.old_personal.vibrant_sales_phone]
    },
    mutations: {
        SET_PRACTICE_DATA(state, practice_obj) {
            state.old_practice = practice_obj
        },
        SET_PERSONAL_DATA(state, personal_obj) {
            state.old_personal = personal_obj
        },
        SET_DEFAULT(state){
            state.old_personal ={}
            state.old_practice ={}
        }
    },
    actions: {
        async getSettingData({ state, rootState, commit }) {
            if (!isObjEmpty(state.old_personal)) return;
            if (pendingFetch) return pendingFetch;

            pendingFetch = (async () => {
                const res = await getSettingData(state.infoURL);
                res.data.clientId = rootState.myPractice.userInfo.clientId;
                res.data.clinicId = rootState.myPractice.userInfo.clinicId;
                res.data.oldClinicId = rootState.myPractice.userInfo.oldClinicId;
                res.data.original_customer_id=rootState.myPractice.userInfo.original_customer_id;
                commit("SET_PERSONAL_DATA", res.data)
            })().finally(() => { pendingFetch = null; });

            return pendingFetch;
        },
        setPracticeData({ commit }, practiceData) {
            commit("SET_PRACTICE_DATA", practiceData)
        },
        setPersonalData({ commit }, personalData) {
            commit("SET_PERSONAL_DATA", personalData)
        },
    },
}

export default account;